import AOS from 'aos';
import 'aos/dist/aos.css';

import './js/toogleModal';
import './js/header';

AOS.init();
